import validateEmailDekaz from '@/js/components/validation/validate_email_dekaz'
import validateEmptyDekaz from '@/js/components/validation/validate_empty_dekaz'
import ajaxphp from '@/js/components/ajax/ajaxphp'
import Swal from 'sweetalert2'
let respuesta
let inputs
const path = document.querySelector('#path')
const phpfile = path.value + '/parts/ajax/ajax-contacto-dekaz.php'
import {emailAnim, emailprocess, emaildone} from '@/js/components/lottie/sendemail'

const formDekaz = document.querySelector('.formulario-dekaz#contacto')

if (formDekaz) {

    const lang = document.documentElement.lang
    let respuesta
    let inputs
    const path = document.querySelector('#path')
    const phpfile = path.value + '/parts/ajax/ajax-contacto-dekaz-contacto.php'
    // console.log(phpfile)
    const loader = document.querySelector('.loader_sendemail')
    const nombre = formDekaz.querySelector('input#nombre')
    const emailAnim2 = emailAnim()
    const email = formDekaz.querySelector('input#email')
    const empresa = formDekaz.querySelector('input#empresa')
    const tel = formDekaz.querySelector('input#telefono')
    const tokenin = formDekaz.querySelector('input#token')
    const asunto = formDekaz.querySelector('textarea#asunto')
    const btnenviar = formDekaz.querySelector('.btnenviar')
    const nombreGroup = formDekaz.querySelector('.input-box-dekaz#nombre')
    const emailGroup = formDekaz.querySelector('.input-box-dekaz#email')
    const telGroup = formDekaz.querySelector('.input-box-dekaz#telefono')
    const empGroup = formDekaz.querySelector('.input-box-dekaz#empresa')

    // console.log(seleComo.selected);
    let labnombre = ''
    let labnombre2 = ''
    let labtelefono = ''
    let labtelefono2 = ''
    let labempresa = ''
    let labempresa2 = ''
    let labemail2 = ''
    let labformrectitle = ''
    let letformrecbaj = ''

    if(lang == "en-US"){
        labnombre = 'NAME'
        labnombre2 = 'ENTER YOUR NAME'
        labtelefono = 'PHONE'
        labtelefono2 = 'ENTER YOUR PHONE'
        labemail2 = 'ENTER YOUR EMAIL'
        labempresa = 'COMPANY'
        labempresa2 = 'ENTER YOUR COMPANY'
        labformrectitle = 'Form received'
        letformrecbaj = 'Soon we will answer you'
    }else {
        labnombre = 'NOMBRE'
        labnombre2 = 'INGRESA TU NOMBRE'
        labtelefono = 'TELÉFONO'
        labtelefono2 = 'INGRESA TU TELÉFONO'
        labemail2 = 'INGRESA TU EMAIL'
        labempresa = 'EMPRESA'
        labempresa2 = 'INGRESA TU EMPRESA'
        labformrectitle = 'Formulario recibido'
        letformrecbaj = 'En breve te contestamos'
    }

    if(tokenin.value != 'no'){
    btnenviar.style.pointerEvents = 'none'
    grecaptcha.ready(function() {
        grecaptcha.execute('6LdxPcgUAAAAAEO3JGwhKOD76zgsj3Zp5iwFwr-H', {
            action: 'homepage'
        }).then(function(token) {
            btnenviar.style.pointerEvents = 'all'
           tokenin.value = token
        })
    })
    } 

    validateEmptyDekaz(nombreGroup, labnombre, labnombre2, true)
    validateEmptyDekaz(telGroup, labtelefono , labtelefono2, true)
    validateEmptyDekaz(empGroup, labempresa , labempresa2, true)
    validateEmailDekaz(emailGroup, 'EMAIL', labemail2, true)

    btnenviar.addEventListener('click', () => {

        let nomvalida = validateEmptyDekaz(nombreGroup, labnombre, labnombre2, false)
        let telvalida = validateEmptyDekaz(telGroup, labtelefono, labtelefono2, false)
        let emavalida = validateEmailDekaz(emailGroup, 'EMAIL', labemail2, false)
        let empvalida = validateEmptyDekaz(empGroup, labempresa, labempresa2, false)

        if (nomvalida && telvalida && emavalida && empvalida) {
            loader.classList.add('active')
            btnenviar.classList.add('envia')
            // console.log('paso');
            emailprocess(emailAnim2)
            inputs = {
                'nombre': nombre.value,
                'email': email.value,
                'tel': tel.value,
                'empresa': empresa.value,
                'asunto': asunto.value,
                'token': tokenin.value,
                'lang': lang
            };
      
            ajaxphp(phpfile, inputs, function (err, response) {
                console.log('respuesta: ' + response, 'error: ' + err);
                respuesta = JSON.parse(response)
                loader.classList.remove('active')
                emaildone(emailAnim2)
                Swal.fire({
                    type: 'success',
                    title: labformrectitle,
                    text: letformrecbaj,
                    timer: 5500
                    // footer: '<a href>Why do I have this issue?</a>'
                  })
            }
            )
        } else {
            btnenviar.classList.add('error')
            setTimeout(() => {
                btnenviar.classList.remove('error')
            }, 600);
        }

    })
}

// import {globalvar} from './../../../../models/globalvar'


// console.log(phpfile)
// var respuesta
